import { api } from "@/services";
import { TraitBoolValue } from "@/utils/TraitBoolValue";
import { Corporate as CorporateObject } from "@/types/Corporate";
type RegisterFormSubmitProps = {
  Data: {
    cnpj: string;
    email: string;
    name: string;
    date: string;
    registration: string;
    phone: string;
    celphone: string;
    password: string;
    zipcode: string;
    street: string;
    number: string;
    complement: string;
    district: string;
    city: string;
    state: string;
    CodIbge: string;
  };
  Corporate: CorporateObject;
};
export async function useRegisterPJClient({ Data, Corporate }: RegisterFormSubmitProps) {
  console.log(Data);
  const Origin = process.env.NEXT_PUBLIC_PRIMARY_STORE || "LINGLONG";
  const RequestJson = JSON.stringify({
    type: "ClientePJ",
    password: Data?.password,
    email: Data?.email,
    registrationOrigin: `${Origin} - shared`,
    paymentPermission: {
      boleto: true,
      credito: true,
      debito: true,
      pix: true
    },
    marketing: {
      indication: null,
      promotion: false,
      whatsapp: false,
      personalizedAds: false
    },
    addresses: [
      {
        rua: Data?.street,
        bairro: Data?.district,
        cidade: Data?.city,
        uf: Data?.state,
        TipoEndereco: "PRINCIPAL",
        latitude: 0,
        longitude: 0,
        codIbge: Data?.CodIbge,
        cep: Data?.zipcode?.replace(/[^0-9]/g, ""),
        complemento: Data?.complement,
        numero: Data?.number
      },
      {
        rua: Data?.street,
        bairro: Data?.district,
        cidade: Data?.city,
        uf: Data?.state,
        TipoEndereco: "ENTREGA",
        latitude: 0,
        longitude: 0,
        codIbge: Data?.CodIbge,
        cep: Data?.zipcode?.replace(/[^0-9]/g, ""),
        complemento: Data?.complement,
        numero: Data?.number
      }
    ],
    telephones: [
      {
        type: "Telefone1",
        number: Data?.phone
      },
      {
        type: "Telefone2",
        number: Data?.phone
      },
      {
        type: "Celular",
        number: Data?.celphone
      }
    ],
    clientPJData: {
      cnpj: Data?.cnpj?.replace(/[^0-9]/g, ""),
      razaoSocial: Data?.name,
      nomeFantasia: Data?.name,
      inscricaoEstadual: Data?.registration,
      contribuinteIcms: Corporate?.registration === null ? false : true,
      termoCompraPJ: true,
      optanteSimples: TraitBoolValue(Corporate?.simples_nacional?.simples_optant),
      declaracaoCnae: true,
      contacts: null
    }
  });

  // * Make a Colored Log in the console with the variable name and value
  let [Response, Error] = [null, null];
  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp = await api.post(`/Client/RegisterBeta`, RequestJson, {
        signal: Controller.signal,
        headers: {
          "Content-Type": "application/json"
        }
      });
      if (resp.data.status) {
        Response = [resp.data.msgs[0]];
      } else {
        Error = ["Erro ao tentar registrar usuário", resp.data.msgs[0]];
      }
    } catch (err) {
      Error = ["Ocorreu um erro ao tentar se comunicar com o servidor.", err.message];
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, Error];
}
